import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const allPairsComparison = api(async function allPairsComparison({ threshold, limit, dimensions } = {}) {
    return query(
        gql`
            query allPairsComparison($threshold: Float, $limit: Int, $dimensions: Int) {
                allPairsComparison(threshold: $threshold, limit: $limit, dimensions: $dimensions) {
                    pair
                    similarity
                }
            }
        `,
        { threshold, limit, dimensions },
        { returns: "allPairsComparison" }
    )
})
